var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.992 10.434L7.923 4.47v6.84c0 .519.42.94.939.94h2.365l-4.931 5.964v-6.841a.939.939 0 0 0-.939-.939zM5.04 21.705a.938.938 0 0 0 1.041-.285l7.863-9.511a.94.94 0 0 0-.723-1.537H9.8v-8.51a.939.939 0 0 0-1.663-.599L.275 10.775a.939.939 0 0 0 .723 1.537h3.42v8.51c0 .396.249.75.622.883z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipper);
export default __webpack_public_path__ + "static/media/zipper.5a8520368b6d3b41ae658b0d8acd07b3.svg";
export { ForwardRef as ReactComponent };